import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import {Twemoji} from 'react-emoji-render';
import {bindActionCreators} from 'redux';
// Redux
import actionSetEmojiContainerIsDisplayed
    from '/chat/src/redux/actions/emoji/actionSetEmojiContainerIsDisplayed';
import style from './style.scss'

class EmojiContainer extends Component
{
    constructor() {
        super();
        this.handleEmojiClick = this.handleEmojiClick.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
    }


    componentDidUpdate(prevProps, prevState){
        if (this.props.emoji.get('isEmojiContainerDisplayed')){
            document.addEventListener('click', this.handleOutsideClick, false);
            this.outsideClickCount = 0;
        }else{
            document.removeEventListener('click', this.handleOutsideClick, false);
        }
    }

    render()
    {
        const emoji = this.props.emoji;
        const isDisplayed = emoji.get('isEmojiContainerDisplayed');

        let display = 'none';
        if(isDisplayed){
            display = 'block';
        }
        const lst = [
            "🙂",
            "😃",
            "😄",
            "😐",
            "😦",
            "😔",
            "😬",
            "🤔",
            "😫",
            "😤",
            "😠",
            "👋",
            "👌",
            "👍",
            "👎",
            "🤝"
          ];

        return (
            <div class={style.Container} style={{display: display}} ref={body => {this.body = body;}}>
                {
                    lst.map( (text, index) => {
                        return <Twemoji
                        svg
                        text={text}
                        key={index}
                        onlyEmojiClassName={style.Emoji}
                        onClick={this.handleEmojiClick}
                      />;
                    })
                }
            </div>
        );
    }

    handleEmojiClick(e) {
        if(e.target.alt != undefined){  // If user presses just between emojis, treat it like nothing happened
            const emojiString = e.target.alt;
            this.props.addToMessageValue(emojiString)
            if(!e.shiftKey){  // If shift-button is held while pressing, don't close the emojidrawer
                this.closeEmojiContainer();
            }
        }
    }

    handleOutsideClick(e) {
        if(!this.body)
            return;
        const emoji = this.props.emoji;
        this.outsideClickCount += 1;
        if (!this.body.contains(e.target) && this.outsideClickCount > 1){
            this.closeEmojiContainer();
        }
    }

    addEmojiToTextareaValue(emojiString) {
        const currentTextareaValue = this.props.inputs.get('chatTextareaValue');
    }

    closeEmojiContainer() {
        this.props.actionSetEmojiContainerIsDisplayed(false);
    }

}

function mapStateToProps(state)
{
    return {
        emoji: state.get('emoji'),
        inputs: state.get('inputs')
    };
}

function matchDispatchToProps(dispatch)
{
    return bindActionCreators({
        actionSetEmojiContainerIsDisplayed: actionSetEmojiContainerIsDisplayed
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(EmojiContainer);



// WEBPACK FOOTER //
// ./routes/Chat/Chat/ChatFooter/EmojiContainer/index.js